import api from '@/apis/di/bankInfoCategoryAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useBankInfoCategoryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBankInfoCategoryComboboxLoadData = (payload, row, column) => {
    payload.sort = 'bank_info_category_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const bankInfoCategoryComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại tài khoản',
        dataField: 'bank_info_category_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại tài khoản',
        dataField: 'bank_info_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'bank_info_category_name',
    valueField: 'bank_info_category_name',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankInfoCategoryComboboxLoadData,
  };

  return {
    bankInfoCategoryComboConfig,
    onBankInfoCategoryComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
